import { z } from 'zod';

export const MapButtonsSchema = z.object({
  panning: z.boolean(),
  zoom: z.boolean(),
});